import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { WaitlistWidget } from "@/components/WaitlistWidget";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#000000] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img
                src="/lovable-uploads/3b945d96-8087-4b84-9ca1-1de1f3e98362.png"
                alt="Savyi Logo"
                className="h-12"
              />
            </Link>
            <p className="text-gray-400 mb-4 max-w-xs">
              Financial freedom that feels like you. We're rebuilding the relationship between people and their money.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com/savyiai" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-[#614AE0] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="https://x.com/savyiai" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="hover:text-[#614AE0] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/savyiai" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-[#614AE0] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
                </svg>
              </a>
              <a href="https://linkedin.com/company/savyiai" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-[#614AE0] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect width="4" height="12" x="2" y="9"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about-us" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/how-it-works" className="text-gray-400 hover:text-white transition-colors">How It Works</Link></li>
              <li><Link to="/timeline" className="text-gray-400 hover:text-white transition-colors">Timeline</Link></li>
              <li><Link to="/faqs" className="text-gray-400 hover:text-white transition-colors">FAQs</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/security" className="text-gray-400 hover:text-white transition-colors">Security</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/bright-plan" className="text-gray-400 hover:text-white transition-colors">Bright Plan</Link></li>
              <li><Link to="/integrations" className="text-gray-400 hover:text-white transition-colors">Integrations</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg mb-4">Support</h3>
            <ul className="space-y-2">
              <li><a href="/knowledgebase.html" className="text-gray-400 hover:text-white transition-colors">Knowledge Base</a></li>
              <li><a href="/contact.html" className="text-gray-400 hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="/privacy.html" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="/terms.html" className="text-gray-400 hover:text-white transition-colors">Terms of Service</a></li>
              <li><Link to="/cookie-settings" className="text-gray-400 hover:text-white transition-colors">Cookie Settings</Link></li>
            </ul>
          </div>
          
          <div className="lg:col-span-2">
            <h3 className="font-semibold text-lg mb-4">Join Our Waitlist</h3>
            <p className="text-gray-400 mb-4">
              Get early access to Savyi and be among the first to experience our revolutionary platform.
            </p>
            <WaitlistWidget variant="default" className="mb-4" />
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Savyi. All rights reserved.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="/contact.html" className="text-gray-400 hover:text-white text-sm">
              Contact Us
            </a>
            <a href="/knowledgebase.html" className="text-gray-400 hover:text-white text-sm">
              Knowledge Base
            </a>
            <Link to="/cookie-settings" className="text-gray-400 hover:text-white text-sm">
              Cookie Settings
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
